<script setup lang="ts"></script>

<template>
  <div class="title">opacity: 0.6; color: white</div>
  <div class="image-highlight">
    <img class="image" src="/images/index-highlight/th/01.png" />
    <div class="effect-overlay effect-gradient"></div>
  </div>

  <div class="title">mix-blend-mode: luminosity; color: gold</div>
  <div class="image-highlight">
    <img class="image" src="/images/index-highlight/05.png" />
    <div class="effect-overlay effect-gradient2"></div>
  </div>
</template>

<style scoped>
.title {
  margin-top: 1rem;
  border-top: 1px dashed gray;
}

.image-highlight {
  position: relative;
  width: 510px;
  height: 370px;
}

.image {
  position: absolute;
}

.effect-overlay {
  position: absolute;
  margin: auto;
  width: 450px;
  height: 320px;
  top: 22px;
  left: 30px;
}

.effect-gradient {
  background: repeating-linear-gradient(55deg, transparent, white, transparent, white);
  background-size: 400% 100%;
  animation: animateBg 3s infinite ease-out;
  opacity: 0.6;
}

@keyframes animateBg {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: 0 0;
  }
}

.effect-gradient2 {
  background: linear-gradient(55deg, gold, transparent, gold, transparent);
  background-size: 300% 100%;
  animation: animateBg2 4s infinite linear;
  mix-blend-mode: luminosity;
}

@keyframes animateBg2 {
  0% {
    background-position: 100% 0;
    opacity: 1;
  }
  50% {
    background-position: 25% 0;
    opacity: 1;
  }
  100% {
    background-position: 0 0;
    opacity: 0;
  }
}


</style>
